import type { ICellRendererParams, IGroupCellRendererParams, IRowNode } from 'ag-grid-community';
import type { QueryOptions } from '@tanstack/vue-query';
import type { CountryCode } from '@sysarb/sysarb-types/general/enums';
import type { PayRangeAddOption, PayRangeNodeType, PayRangeTreeNode } from '@sysarb/sysarb-types-v2/services/v1/job/payRange';
export { PayRangeAddSection } from '@sysarb/sysarb-types-v2/services/v1/job/payRange';
export type { PayRangeAddOption as PayRangeMenuOption } from '@sysarb/sysarb-types-v2/services/v1/job/payRange';

type NodeType = 'country' | 'grade' | 'legalEntity' | 'jobFamily';
export type PayRangeRow = {
    id: string;
    path: string[];
    nodeType: NodeType;
    name: string;
    countryCode?: CountryCode;
    salaryType?: string;
    min: number | null;
    midpoint: number | null;
    max: number | null;
    comment: string;
    isAllLegalEntities?: boolean;
};

// Frontend-only node type extensions (not from backend)
export enum PayRangeNodeTypeExtra {
    grade = 'grade',
    country = 'country',
}
export type PayRangeNodeTypeExtended = PayRangeNodeType | PayRangeNodeTypeExtra;

export type PayRangeNameCellRendererCustomParams = IGroupCellRendererParams<PayRangeTreeNode> & {
    onAdd: (option: PayRangeAddOption, selectedNames: string[]) => void;
    getNodeOptions?: (nodeId: string) => QueryOptions<PayRangeAddOption[], Error, PayRangeAddOption[]>;
    noEmployeesWarning?: (node: PayRangeTreeNode | undefined) => string | null;
    hasNoOptions?: (nodeId: string) => boolean;
    onCheckboxClick: (node: IRowNode<PayRangeTreeNode>, checked: boolean, shiftKey: boolean) => void;
};

export type PayRangeNameCellRendererParams = ICellRendererParams<PayRangeTreeNode> & PayRangeNameCellRendererCustomParams;

// The published view renders no add-menu, so it takes only the warning off the params above.
export type PayRangePublishedNameCellRendererParams = ICellRendererParams<PayRangeTreeNode> & Pick<PayRangeNameCellRendererCustomParams, 'noEmployeesWarning'>;
